// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ea4dd44f","453":"2eb12ab7","732":"adf18677"}[chunkId] + ".chunk.js";
};